import React, { useMemo } from "react";
import CreativeCarouselBase from "@/features/campaigns/components/CreativeCarousel";
import { getPackageChannelId } from "@/features/campaigns/shared/helpers/channelSelectionHelper";

type PackageChannel = {
  disabled?: boolean;
  [key: string]: unknown;
};

type CreativePackage = {
  creative_id?: string | number;
  package_channels?: PackageChannel[];
  [key: string]: unknown;
};

type CreativeChannelsProps = {
  creatives?: CreativePackage[];
  view?: string | number;
  channelSelectionEnabled?: boolean;
  selectedChannelIds?: Array<string | number>;
  loc?: unknown;
  campaign?: unknown;
};

const CreativeCarousel =
  CreativeCarouselBase as unknown as React.ComponentType<{
    channels?: PackageChannel[];
  }>;

export default function CreativeChannels({
  creatives = [],
  view,
  channelSelectionEnabled = false,
  selectedChannelIds = [],
}: CreativeChannelsProps) {
  const selectedChannelIdSet = useMemo(() => {
    return new Set(selectedChannelIds.map((channel) => String(channel)));
  }, [selectedChannelIds]);

  const getCreativeChannels = useMemo(() => {
    const creative = creatives.find((c) => c.creative_id === view);
    const channels = creative ? creative.package_channels : [];

    if (!channelSelectionEnabled) {
      return channels;
    }

    return channels.map((channel) => ({
      ...channel,
      disabled: !selectedChannelIdSet.has(
        getPackageChannelId(channel as never)
      ),
    }));
  }, [channelSelectionEnabled, creatives, selectedChannelIdSet, view]);

  // const creativeName = useMemo(() => {
  //   const creative = creatives.find((c) => c.creative_id === view);
  //   return creative ? creative.creative_name : "";
  // }, [creatives, view]);

  return (
    <>
      <div className="creative-channels">
        {/* {selectedBrand?.id !== 3 && creativeName ? (
          <div className="d-flex align-items-center justify-content-end mb-2 mb-sm-0">
            <RpPopover popContent="Provide Feedback">
              <Button
                size="small"
                endIcon={<Icon color="primary">feedback</Icon>}
                onClick={() => setFeedback(true)}
              ></Button>
            </RpPopover>
          </div>
        ) : null} */}
        <div className="card">
          <div className="cord-body">
            <CreativeCarousel channels={getCreativeChannels} />
          </div>
        </div>
      </div>
      {/* <RpMUIDialog
        open={feedback}
        onClose={() => setFeedback(false)}
        fullWidth
        maxWidth="md"
        heading="Creative feedback"
      >
        <ParticipantFeedback
          close={() => setFeedback(false)}
          creativeId={view}
          creativeName={creativeName}
          campaign={campaign}
          location={loc}
        />
      </RpMUIDialog> */}
    </>
  );
}
